import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ShapeTypeEnum } from '@inter-ikea-storageone/range';
import { RootState } from 'ducks';

export type HelpLinesState = {
  isActive: boolean;
  shape: ShapeTypeEnum;
  showHelpLinesCollisionWarningSheet: boolean;
  labelsVisible: boolean;
  linesVisible: boolean;
};

const initialState: HelpLinesState = {
  isActive: false,
  shape: ShapeTypeEnum.off,
  showHelpLinesCollisionWarningSheet: false,
  labelsVisible: true,
  linesVisible: true
};

const helpLinesSlice = createSlice({
  name: 'HelpLinesSlice',
  initialState,
  reducers: {
    setShape(state, action: PayloadAction<ShapeTypeEnum>) {
      state.shape = action.payload;
    },
    showHelpLinesCollisionWarningSheet(state, action: PayloadAction<boolean>) {
      state.showHelpLinesCollisionWarningSheet = action.payload;
    },
    setHelpLinesLabelsVisible(state, action: PayloadAction<boolean>) {
      state.labelsVisible = action.payload;
    },
    setHelpLinesVisible(state, action: PayloadAction<boolean>) {
      state.linesVisible = action.payload;
    }
  }
});

export const isHelpLinesActive = (state: RootState) => state.helpLines.isActive;
export const helpLinesShape = (state: RootState) => state.helpLines.shape;
export const helpLinesCollisionWarningSheetVisible = (state: RootState) =>
  state.helpLines.showHelpLinesCollisionWarningSheet;
export const helpLinesLabelsVisible = (state: RootState) => state.helpLines.labelsVisible;
export const helpLinesVisible = (state: RootState) => state.helpLines.linesVisible;

export const {
  setShape,
  showHelpLinesCollisionWarningSheet,
  setHelpLinesLabelsVisible,
  setHelpLinesVisible
} = helpLinesSlice.actions;
export default helpLinesSlice.reducer;
